module.exports = __webpack_public_path__ + "static/media/myZoneTicketingBlack.5cf6ffa6.svg";